import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ListGroup } from 'reactstrap';

import {
  stopRecording,
  setShowStopStreamConfirmation,
  stopStreams
} from 'actions/Broadcast';

import ActiveStreamListItems from 'components/ActiveStream/ActiveStreamListItems';

import {
  StyledModalConfirmButton,
  StyledModalCancelButton
} from 'components/Modal/Button.styled';

import { StyledModalFooter } from './ActiveStreamList.styled';

const getActiveStreams = (...streams) => {
  const allStreams = streams.reduce(
    (accumulator, currentItem = {}) => [...accumulator, ...currentItem],
    []
  );

  if (allStreams.length) {
    return allStreams.filter(
      stream => !!stream.taskId || stream.isLive === true || stream.isPreviewing
    );
  }
};

const ActiveStreamList = ({ streams, redirectToEventDash, onModalClose }) => {
  const dispatch = useDispatch();

  const {
    broadcastStreamEndpoints,
    showStopStreamConfirmation,
    broadcastRecordings: { pastRecordings, liveRecordings }
  } = useSelector(state => state);

  if (!streams) return null;

  const activeStreams = getActiveStreams(
    liveRecordings,
    broadcastStreamEndpoints
  );

  const handleStopStream = stream => {
    if (stream.s3Key) dispatch(stopRecording(stream._id));
    if (stream.streamKey) dispatch(stopStreams([stream._id]));
  };

  const handleConfirmation = (id, value) => {
    dispatch(
      setShowStopStreamConfirmation({
        [id]: value
      })
    );
  };

  const getById = (items = [], id) => items.filter(item => item._id === id);

  const checkIsRecordingStopped = id => {
    const items = getById(pastRecordings, id)[0];

    return items && !!items.endedAt;
  };

  const checkEnpointStreamStopped = id => {
    const items = getById(broadcastStreamEndpoints, id)[0];

    return items && !items.taskId;
  };

  const isStreamStopped = stream => {
    let isStreamStopped = false;

    if (stream.s3Key) isStreamStopped = checkIsRecordingStopped(stream._id);
    if (stream.streamKey)
      isStreamStopped = checkEnpointStreamStopped(stream._id);

    return isStreamStopped;
  };

  const buttonTitle =
    activeStreams && activeStreams.length ? 'Leave without stopping' : 'Leave';

  return (
    <>
      <ListGroup>
        {streams &&
          streams.map(stream => (
            <ActiveStreamListItems
              key={stream.title}
              stream={stream}
              showStopStreamConfirmation={showStopStreamConfirmation}
              handleConfirmation={handleConfirmation}
              handleStopStream={handleStopStream}
              isStreamStopped={isStreamStopped}
            />
          ))}
      </ListGroup>
      <StyledModalFooter>
        <StyledModalConfirmButton color="primary" onClick={redirectToEventDash}>
          {buttonTitle}
        </StyledModalConfirmButton>
        <StyledModalCancelButton outline onClick={onModalClose}>
          Cancel
        </StyledModalCancelButton>
      </StyledModalFooter>
    </>
  );
};

ActiveStreamList.propTypes = {
  streams: PropTypes.array,
  redirectToEventDash: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired
};

export default ActiveStreamList;
